import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  addtagsegment: option => request('v1/tag/addtagsegment', option, true, false), // 生产标签-非套码
  gettagsegments: option =>
    request('v1/tag/gettagsegments', option, true, false), // 查询标签生产记录-非套码
  gettagassigns: option => request('v1/tag/gettagassigns', option, true, false), // 查询标签分配记录列表-非套码
  getvendornames: option =>
    request('v1/vendor/getvendornames', option, true, false), // 根据标签查询企业
  getnexttagsegmentinfo: option =>
    request('v1/tag/getnexttagsegmentinfo', option, true, false), // 查询要生产的下一段标签的信息
  assignpooltagsegment: option =>
    request('v1/tag/assignpooltagsegment', option, true, false), // 分配通用池标签-非套码
  downloadtagsegment: option => {
    const urls = querystring(option)
    return request('v1/tag/downloadtagsegment' + urls, option, true, false, true) // 下载标签-非套码
  },
  addsetsegment: option =>
    request('v1/tag/set/addsetsegment', option, true, false), // 生产套码
  getsetassigns: option =>
    request('v1/tag/set/getsetassigns', option, true, false), // 查询套码分配记录列表
  getsetsegments: option =>
    request('v1/tag/set/getsetsegments', option, true, false), // 查询套码生产纪录列表
  assignpoolsetsegment: option =>
    request('v1/tag/set/assignpoolsetsegment', option, true, false), // 企业分配套码
  getnextsetsegmentinfo: option =>
    request('v1/tag/set/getnextsetsegmentinfo', option, true, false), // 查询要生产的下一段套码的信息
  downloadsetsegment: option => {
    const urls = querystring(option)
    return request('v1/tag/set/downloadsetsegment' + urls, option, true, false, true) // 下载套码
  },
  gettagusedinfo: option => {
    const urls = querystring(option)
    return request('v1/tag/gettagusedinfo' + urls, {}, true, false) // 查询企业的标签使用信息
  },
  gettagcodes: option => {
    const urls = querystring(option)
    return request('v1/tag/gettagcodes' + urls, {}, true, false)
  }, // 根据序号查标签
  gettagprofile: option => {
    const urls = querystring(option)
    return request('v1/stats/gettagprofile' + urls, {}, true, false)
  }, // 根据标签查状态
  gettagassignuseddetails: option => {
    const urls = querystring(option)
    return request('v1/tag/gettagassignuseddetails' + urls, {}, true, false)
  }, // 查询标签分配段使用详情
  gettagassignsums: option =>
    request('v1/tag/gettagassignsums', option, true, false), // 查询标签分配汇总记录
  getsetassignsums: option =>
    request('v1/tag/set/getsetassignsums', option, true, false), // 查询套码分配汇总记录
  gettagsegmentdetailses: option =>
    request('v1/tag/gettagsegmentdetailses', option, true, false), // 查询标签分配汇总记录
  getsetsegmentdetailses: option =>
    request('v1/tag/set/getsetsegmentdetailses', option, true, false), // 查询套码分配汇总记录
  sumpooltags: option => request('v1/tag/sumpooltags', option, true, false), // 查询套码分配汇总记录
  deassigntpooltagsegment: option => request('v1/tag/deassigntpooltagsegment', option, true, false), // 重置已分配的通用池
  addbadtags: option => request('v1/tag/badtag/addbadtags', option, true, false), // 重置已分配的通用池
  getbadtags: option => request('v1/tag/badtag/getbadtags', option, true, false), // 重置已分配的通用池
  gettagsegmentinfo: option => request('v1/tag/gettagsegmentinfo', option, true, false), // 重置已分配的通用池
  deletebadtagbytagnoseg: option => request('v1/tag/badtag/deletebadtagbytagnoseg' + querystring(option), option, true, false), // 重置已分配的通用池
  deletebadtag: option => request('v1/tag/badtag/deletebadtag' + querystring(option), option, true, false), // 重置已分配的通用池
  updatetagsegmentremarks: option => request('v1/tag/updatetagsegmentremarks' + querystring(option), option, true, false) // 修改通用池备注
}
